import * as React from "react";

import "./size-chart-modal.scss";

import { cs }           from "@Common/react/chain-services";
import { DeprecatedModalService2 } from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const SizeChartModal = ({ url, next: rootNext }) => cs(
    ["modal", ({}, next) => (<DeprecatedModalService2{...{
        render: ({}, rm) => ({
            size: 632,
            content: next({
                onSelect: () => {
                    rm();
                },
            })
        }),
        next: rootNext,
    }}/>)],
    ({}) => (
        <div className="size-chart-modal-do8">
            <div className="title">Size Chart</div>
            <object className="modal-img" data={url} type="application/pdf">
                <embed src={url} type="application/pdf"/>
            </object>
        </div>
    )
);
